import { createSlice } from '@reduxjs/toolkit'

export const cheapestPrice = createSlice({
  name: 'cheapestPrice',
  initialState: [],
  reducers: {
    setCheapestPrice: (state, action) => {
      const existingIndex = state.findIndex((i) => i.sliceId === action.payload.sliceId)
      if (existingIndex >= 0) {
        state[existingIndex] = action.payload
      } else {
        state.push(action.payload)
      }

      return state
    },
  },
})

export const { setCheapestPrice } = cheapestPrice.actions
